import { IconCheckDefault } from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';

import styles from './TrueLayerLinkedAccountsList.module.css';

type TLinkedBankAccount = {
  bank_name: string;
  logo_url: string;
  account_number_masked: string;
  provider_id: string;
};

type TProps = {
  linkedBankAccounts?: Array<TLinkedBankAccount>;
};

/**
 * Separate Linked Account component to display multiple linked accounts for Shareable link page.
 */
export const TrueLayerLinkedAccountsList = ({ linkedBankAccounts }: TProps) => {
  if (!linkedBankAccounts || linkedBankAccounts.length === 0) return null;

  return (
    <>
      <div className={styles.linkedAccountsListHeader}>
        <IconCheckDefault className={styles.iconCheck} />
        <h3>Business bank transaction data</h3>
      </div>
      {linkedBankAccounts.map((account) => {
        const bankName = account.bank_name;
        const bankNumber = account.account_number_masked;

        return (
          <AlertBox
            key={`${account.provider_id}-${bankNumber}`}
            className={styles.bankAccountStatus}
            variant="connect"
          >
            <img
              className={styles.trueLayerBankLogo}
              src={account.logo_url}
              alt={account.bank_name}
            />
            {bankNumber ? (
              <strong>
                Your {bankName} account ending in {bankNumber} now linked.
              </strong>
            ) : (
              <strong>Your {bankName} account is now linked.</strong>
            )}
          </AlertBox>
        );
      })}
    </>
  );
};
